"use strict";
// models/lists.js
Object.defineProperty(exports, "__esModule", { value: true });
exports.typeClient = exports.tvaList = exports.typeDocumentList = exports.localesList = exports.typesActivitesList = void 0;
const globals_1 = require("models/globals");
exports.typesActivitesList = [
    "Marche Nordique",
    "Randonnée",
    "Autre"
];
exports.localesList = [
    "en-US",
    "ru-RU",
    "fr-FR",
    "ja-JP",
    "be-BY",
    "de-DE",
    "es-ES",
    "it-IT",
    "zh-CN",
    "pt-BR"
];
// TODO : dé-dupliquer ces données en arrière plan
exports.typeDocumentList = [
    { "id": 1, "value": (0, globals_1._)("Facture") },
    { "id": 2, "value": (0, globals_1._)("Devis") },
    { "id": 3, "value": (0, globals_1._)("Pro-forma") },
    { "id": 4, "value": (0, globals_1._)("Commande") },
    { "id": 5, "value": (0, globals_1._)("Bon de livraison") },
    { "id": 6, "value": (0, globals_1._)("Accusé de réception de commande") },
    { "id": 7, "value": (0, globals_1._)("Bon de réception") },
    { "id": 8, "value": (0, globals_1._)("Commande fournisseur") },
    { "id": 9, "value": (0, globals_1._)("Bon de retour client") },
    { "id": 10, "value": (0, globals_1._)("Panier") },
    { "id": 11, "value": (0, globals_1._)("Bon de retour fournisseur") },
    { "id": 12, "value": (0, globals_1._)("Ticket de caisse") },
    { "id": 13, "value": (0, globals_1._)("Retour garantie") },
    { "id": 14, "value": (0, globals_1._)("Avoir") },
    { "id": 15, "value": (0, globals_1._)("Facture fournisseur") },
    { "id": 20, "value": (0, globals_1._)("Groupe de documents") },
    { "id": 21, "value": (0, globals_1._)("Relevé de factures") },
    { "id": 22, "value": (0, globals_1._)("Abonnement") },
];
const tvaList = function () {
    // ATTENTION, les libellés de TVA sont également dans la table "libelles"
    if (globals_1.lv2.ihm.comptabiliteTenueHorsTaxes == "Oui") {
        return ([
            { "id": 1, "value": (0, globals_1._)("TVA 20%"), "taux": "20", "Achats": "XXX", "Vente": "XXX", "Fin": "31-12-2100", "Motif": "Fin du monde" },
            { "id": 2, "value": (0, globals_1._)("TVA 10%"), "taux": "10", "Achats": "XXX", "Vente": "XXX", "Fin": "31-12-2100", "Motif": "Fin du monde" },
            { "id": 3, "value": (0, globals_1._)("TVA 5,5%"), "taux": "5.5", "Achats": "XXX", "Vente": "XXX", "Fin": "31-12-2100", "Motif": "Fin du monde" },
            { "id": 4, "value": (0, globals_1._)("TVA 2,1%"), "taux": "2.1", "Achats": "XXX", "Vente": "XXX", "Fin": "31-12-2100", "Motif": "Fin du monde" },
            { "id": 5, "value": (0, globals_1._)("Pas de TVA"), "taux": "0.0", "Achats": "XXX", "Vente": "XXX", "Fin": "31-12-2100", "Motif": "Fin du monde" }
        ]);
    }
    else {
        return ([
            { "id": 6, "value": (0, globals_1._)("TTC"), "taux": "0.0", "Achats": "XXX", "Vente": "XXX", "Fin": "31-12-2100", "Motif": "Facturation TTC" }
        ]);
    }
};
exports.tvaList = tvaList;
// export const natureArticle = new webix.DataCollection({
// 	url : phpPath + "natureProduit.php?option=shortList"
// });
exports.typeClient = [
    { "id": 1, "value": (0, globals_1._)("Client") },
    { "id": 2, "value": (0, globals_1._)("Client livraison") }, // adresses de livraison, la fiche contient l'IdClient du client principal
];
